import { appConfig } from './config/app.config';
import { isFieldValid, getQueryParamFromUrl, getUrlWithoutParam, togglePassword } from './functions/utils.functions';
import { IDocument } from './models';

export class AccountCreationForm {

	// Form elements
	$form = $('#account-creation-form');
	$submitBtn = $('#btn-submit');
	$cancelBtn = $('#btn-cancel');

	// Fields elements
	$emailField = $('#Email');
	$verificationCodeField = $('#MailVerificationCode');
	$wantedPasswordField = $('#WantedPassword');
	$wantedPasswordConfirmationField = $('#WantedPasswordConfirmation');
	$cguAcceptedField = $('#CguAccepted');
	$cguAcceptedIdField = $('#CguAcceptedId');
	$redirectUrlField = $('#RedirectUrl');

	$togglePassword = $(".toggle-password");

	// Verification code elements
	$sendCodeBtn = $('#btn-send-code').attr('disabled', 'disabled');
	$resendCodeBtn = $('#btn-resend-code');
	$sendCodeBlock = $('#send-code');
	$checkCodeBlock = $('#check-code').hide();
	$passwordsGroupBlock = $('#passwords-group').addClass('form-group-disabled');

	// Url params
	returnUrl: string = getQueryParamFromUrl('returnUrl');
	originUrl: string = '';

	// State
	isEmailVerified: boolean = false;
	isCodeSent: boolean = false;
	isCodeSending: boolean = false;
	isCodeVerified: boolean = false;

	// CGU
	$closeCguBtn = $('#btn-close-cgu');
	$termsAndConditionsModal = $('#terms-and-conditions-modal');

	constructor() {
	}

    init() {
        this.setValidators();
		this.getTermsAndConditionsDocument();
        this.$form.on('blur keyup change', 'input', (e) => {
			this.$submitBtn.prop("disabled", !this.$form.validate().checkForm());
        });

		// Origin url is a query param of the return url so we have to extract it manually too
		if (this.returnUrl) {
			this.originUrl = getQueryParamFromUrl('origin', this.returnUrl);
			this.returnUrl = getUrlWithoutParam('origin', this.returnUrl);

			this.$redirectUrlField.val(decodeURIComponent(this.returnUrl));
			this.$cancelBtn.attr('href', decodeURIComponent(this.originUrl));
		}

        this.$emailField.on('validityUpdate', (e) => {
			this.isEmailVerified = isFieldValid(this.$emailField);

			if (!this.isEmailVerified) {
				this.isCodeSent = false;
				this.isCodeVerified = false;
			}

			this.render();
		});

		this.$verificationCodeField.on('validityUpdate', (e) => {
			this.isCodeVerified = isFieldValid(this.$verificationCodeField);

			this.render();
		});

		this.$sendCodeBtn.on('click', (e) => {
			e.preventDefault();
			this.sendVerificationCode();
		});

		this.$resendCodeBtn.on('click', (e) => {
			e.preventDefault();
			this.$verificationCodeField.val('');
			this.sendVerificationCode(true);
		});

		this.$closeCguBtn.on('click', (e) => {
			e.preventDefault();
			this.$termsAndConditionsModal.modal('hide');
		});

		this.$togglePassword.click(function() {togglePassword($(this))});
    }

    setValidators() {
        this.$form.validate({
            rules: {
                FirstName: {
                    required: true,
                    minlength: 2,
                    maxlength: 100,
                    humanname: true
                },
                LastName: {
                    required: true,
                    minlength: 2,
                    maxlength: 100,
                    humanname: true
                },
                MobilePhoneNumber: {
                    required: true,
                    minlength: 6,
                    maxlength: 25,
                    pattern: "^[0-9()+]*$"
                },
                Email: {
                    required: true,
                    email: true,
                    maxlength: 100,
                    remote: {
                        url: `${appConfig.apiUrl}/api/User/isEmailAvailable`,
                        type: 'post'
                    }
                },
                MailVerificationCode: {
                    required: true,
                    minlength: 6,
                    maxlength: 6,
                    digits: true,
                    remote: {
                        url: `${appConfig.apiUrl}/Account/IsMailVerificationCodeValid`,
                        type: 'post',
                        data: {
                            email: () => this.$emailField.val(),
                            code: () => this.$verificationCodeField.val()
                        }
                    }
                },
                WantedPassword: {
                    required: true,
                    minlength: 8,
                    nowhitespace: true,
                    lowercaseChar: true,
                    uppercaseChar: true,
                    digitChar: true,
                    specialChar: true,
                },
                WantedPasswordConfirmation: {
                    required: true,
                    equalTo: '#WantedPassword'
                },
                CguAccepted: {
                    required: true
                },
                CguAcceptedId: {
                    required: true,
                    digits: true,
                    min: 1
                },
                RedirectUrl: {
                    required: true
                },
                RgpdAccepted: { required: true }
            },
            messages: {
                MailVerificationCode: {
                    remote: jQuery.validator.messages['codeInvalid']
                },
                Email: {
                    remote: jQuery.validator.messages['emailUsed']
                },
                MobilePhoneNumber: {
                    pattern: jQuery.validator.messages["mobilePhoneNumber"]
                }
            }
        });

        this.$form.validate().checkForm();

        this.render();
    }

	sendVerificationCode(isRetry: boolean = false) {
		if (!isRetry) {
			this.isCodeSent = false;
		}

		this.isCodeSending = true;
		this.render();

		$.ajax({
			url: `${appConfig.apiUrl}/Account/SendEmailVerificationCode`,
			type: 'POST',
			data: {
				targetEmail: this.$emailField.val()
			},
			success: _ => {
				this.isCodeSent = true;
			},
			complete: _ => {
				this.isCodeSending = false;
				this.render();
			}
		});
	}

	getTermsAndConditionsDocument() {
		$.get(`${appConfig.apiUrl}/api/Documents/cgu/latest`, (data: IDocument) => {
			this.$cguAcceptedIdField.val(data.id);
		});
    }

    render() {
		// Send code button
		this.$sendCodeBtn.attr('disabled', this.isEmailVerified ? null : 'disabled');

		// Code block visibility
		if (this.isCodeSent && this.isEmailVerified) {
			this.$sendCodeBlock.hide();
			this.$checkCodeBlock.show();
		} else {
			this.$sendCodeBlock.show();
			this.$checkCodeBlock.hide();
        }

		// Password fields
        this.$passwordsGroupBlock.removeClass('form-group-disabled').addClass(this.isCodeVerified ? null : 'form-group-disabled');
		this.$wantedPasswordField.attr('disabled', this.isCodeVerified ? null : 'disabled');
		this.$wantedPasswordConfirmationField.attr('disabled', this.isCodeVerified ? null : 'disabled');
	}
}
